export const convertDateFromSelectToISOFormat = (
  timeString: string | undefined
) => {
  if (timeString) {
    const [hours, minutes] = timeString.split(':');
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;

    return isoString;
  } else {
    return null;
  }
};
